var map = {
	"../pages/cart/cart.module": [
		891,
		7
	],
	"../pages/contentpreview/contentpreview.module": [
		890,
		0
	],
	"../pages/forgotpwd/forgotpwd.module": [
		892,
		6
	],
	"../pages/intro-slider/intro-slider.module": [
		893,
		5
	],
	"../pages/portfolios/portfolios.module": [
		894,
		4
	],
	"../pages/search/search.module": [
		895,
		3
	],
	"../pages/setting/setting.module": [
		896,
		2
	],
	"../pages/user-carts/user-carts.module": [
		897,
		1
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 260;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src lazy
// module id = 260
// module chunks = 8